/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlanEntitlementResponse } from './PlanEntitlementResponse';
import {
    PlanEntitlementResponseFromJSON,
    PlanEntitlementResponseFromJSONTyped,
    PlanEntitlementResponseToJSON,
    PlanEntitlementResponseToJSONTyped,
} from './PlanEntitlementResponse';

/**
 * 
 * @export
 * @interface PlanResponse
 */
export interface PlanResponse {
    /**
     * 
     * @type {string}
     * @memberof PlanResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PlanResponse
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof PlanResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PlanResponse
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PlanResponse
     */
    tierRank: number;
    /**
     * 
     * @type {string}
     * @memberof PlanResponse
     */
    billingInterval: string;
    /**
     * 
     * @type {number}
     * @memberof PlanResponse
     */
    priceCents: number;
    /**
     * 
     * @type {string}
     * @memberof PlanResponse
     */
    currency: string;
    /**
     * 
     * @type {boolean}
     * @memberof PlanResponse
     */
    selfServiceSelectable: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PlanResponse
     */
    active: boolean;
    /**
     * 
     * @type {Array<PlanEntitlementResponse>}
     * @memberof PlanResponse
     */
    entitlements: Array<PlanEntitlementResponse>;
}

/**
 * Check if a given object implements the PlanResponse interface.
 */
export function instanceOfPlanResponse(value: object): value is PlanResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('tierRank' in value) || value['tierRank'] === undefined) return false;
    if (!('billingInterval' in value) || value['billingInterval'] === undefined) return false;
    if (!('priceCents' in value) || value['priceCents'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('selfServiceSelectable' in value) || value['selfServiceSelectable'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('entitlements' in value) || value['entitlements'] === undefined) return false;
    return true;
}

export function PlanResponseFromJSON(json: any): PlanResponse {
    return PlanResponseFromJSONTyped(json, false);
}

export function PlanResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlanResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'tierRank': json['tierRank'],
        'billingInterval': json['billingInterval'],
        'priceCents': json['priceCents'],
        'currency': json['currency'],
        'selfServiceSelectable': json['selfServiceSelectable'],
        'active': json['active'],
        'entitlements': ((json['entitlements'] as Array<any>).map(PlanEntitlementResponseFromJSON)),
    };
}

export function PlanResponseToJSON(json: any): PlanResponse {
    return PlanResponseToJSONTyped(json, false);
}

export function PlanResponseToJSONTyped(value?: PlanResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'name': value['name'],
        'description': value['description'],
        'tierRank': value['tierRank'],
        'billingInterval': value['billingInterval'],
        'priceCents': value['priceCents'],
        'currency': value['currency'],
        'selfServiceSelectable': value['selfServiceSelectable'],
        'active': value['active'],
        'entitlements': ((value['entitlements'] as Array<any>).map(PlanEntitlementResponseToJSON)),
    };
}

